import * as k4util from "@/utils/k4util";

import ConditionNode from "./conditionNode";
import DelayNode from "./delayNode";
import IntervalNode from "./intervalNode";
import Node from "./baseNode";
import PropertyNode from "./propertyNode";
import SceneNode from "./sceneNode";
import StepNode from "./stepNode";
import TriggerNode from "./triggerNode";

// Static helper method for detecting and instantiating the correct node subclass
Node.create = function(k4node) {
	const isNode = !!k4node.guid();

	if (k4util.isProperty(k4node)) {
		return new PropertyNode(k4node);
	}

	if (isNode)
		switch (k4node.cls()) {
			case k4util.DEVICE_CLASS_CONDITION:
				return ConditionNode.create(k4node);
			case k4util.DEVICE_CLASS_DELAY:
				return new DelayNode(k4node);
			case k4util.DEVICE_CLASS_INTERVAL:
				return new IntervalNode(k4node);
			case k4util.DEVICE_CLASS_SCENE:
				return new SceneNode(k4node);
			case k4util.DEVICE_CLASS_STEP:
				return new StepNode(k4node);
			case k4util.DEVICE_CLASS_TRIGGER:
				return new TriggerNode(k4node);
		}

	return new Node(k4node);
};

export default Node;

export { ConditionNode, SceneNode, StepNode, TriggerNode };
